import { connect } from 'react-redux';
import { selectUserGeneralTosStatus } from '../../../ReduxStorage/LoggedInUser/selectors';
import { ReduxState } from '../../../ReduxStorage/state';
import { TosSnackbar } from './component';
import { currentUserIdSelector } from '../../../ReduxStorage/Auth/selectors';
import { acceptTermsOfService } from '../../../ReduxStorage/Application/asyncActions';

export const ConnectedTosSnackbar = connect(
  (state: ReduxState) => ({
    userGeneralTosStatus: selectUserGeneralTosStatus(state),
    currentUserId: currentUserIdSelector(state),
  }),
  {
    acceptTermsOfService,
  }
)(TosSnackbar);
